<template>
  <div>
    <div class="bodyElement header">
      <h1 class="bigTitle">Election Probability</h1>
    </div>
    <div class="bodyElement">
      <ElectionProbability currentView="FederalView" />
    </div>
  </div>
</template>
<script>
import ElectionProbability from "../components/election-probability/ElectionProbability.vue";

export default {
  name: "ElectionProbabilityView",
  components: {
    ElectionProbability,
  },
};
</script>
<style src="../css/app.css"></style>
